module.exports = __webpack_public_path__ + "img/camera_board2.fe5c6e46.png";